import { FaEye, FaTrash } from 'react-icons/fa'
import { IoCloseOutline } from 'react-icons/io5'

const ModalSavedPlans = ({ savedPlans, onClose, onDelete, lists }) => {
	const formatDate = dateString => {
		const options = { day: 'numeric', month: 'long', year: 'numeric' }
		const date = new Date(dateString)
		return date.toLocaleDateString('pt-BR', options)
	}

	return (
		<>
			<div
				className={`tw-fixed tw-inset-0 tw-bg-gray-600 tw-bg-opacity-50 tw-flex tw-justify-center tw-items-center ${
					savedPlans ? 'tw-block' : 'tw-hidden'
				}`}
				style={{ zIndex: 9999 }}
			>
				<div className='tw-bg-white tw-rounded-lg tw-w-3/4 tw-shadow-lg tw-overflow-hidden'>
					<div className='tw-flex tw-justify-between tw-items-center tw-px-6 tw-pt-4 '>
						<h2 className='tw-text-xl tw-font-semibold'>Planos de Sucessão</h2>
						<div onClick={onClose} className='tw-bg-gray-100 hover:tw-bg-gray-200 tw-px-2 tw-py-1 tw-rounded-full tw-cursor-pointer'>
							<IoCloseOutline />
						</div>
					</div>

					<div className='tw-overflow-x-auto tw-m-10'>
						<div className='tw-max-h-96 tw-overflow-y-auto'>
							<table className='tw-w-full tw-text-left tw-table-auto'>
								<thead>
									<tr className='tw-bg-gray-100'>
										<th className='tw-px-6 tw-py-4 tw-font-medium tw-text-gray-600'>Nome</th>
										<th className='tw-px-6 tw-py-4 tw-font-medium tw-text-gray-600'>País</th>
										<th className='tw-px-6 tw-py-4 tw-font-medium tw-text-gray-600'>Data</th>
										<th className='tw-px-6 tw-py-4 tw-font-medium tw-text-gray-600'>Ações</th>
									</tr>
								</thead>

								<tbody>
									{savedPlans.map((plan, index) => (
										<tr key={index} className='hover:tw-bg-purple-50'>
											<td className='tw-px-6 tw-py-4'>
												<span className='tw-text-gray-600 '>{plan.filename}</span>
											</td>
											<td className='tw-px-6 tw-py-4'>
												<span className='tw-text-gray-600'>
													{lists.countries.find(country => String(country.id) === String(plan.countryId))?.value}
												</span>
											</td>
											<td className='tw-px-6 tw-py-4'>
												<span className='tw-text-gray-600'>{formatDate(plan.createdAt)}</span>
											</td>
											<td className='tw-px-6 tw-py-4'>
												<div className='tw-flex tw-space-x-3'>
													<div className='tw-bg-gray-100 hover:tw-bg-gray-200 tw-px-2 tw-py-1 tw-rounded-full tw-cursor-pointer'>
														<FaEye />
													</div>

													<div
														className='tw-bg-error-100 hover:tw-bg-error-200 tw-text-error-600 tw-px-2 tw-py-1 tw-rounded-full tw-cursor-pointer'
														onClick={() => onDelete(plan.id)}
													>
														<FaTrash />
													</div>
												</div>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default ModalSavedPlans
